import { StatisticalAnalysisTemporalFilterEnum } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-temporal-filter/statistical-analysis-temporal-filter.model'
import { StatisticalAnalysisCaseTypes, StatisticalAnalysisCommonStats, StatisticalAnalysisContentScrollTable, StatisticalAnalysisExternalListTypes, StatisticalAnalysisViewDetailTableGroupingColumns } from '@/modules/statistical-analysis-module/shared/models/shared.model'
import { Nullable } from '@/shared/types/app.types'

export enum StatisticalAnalysisGeneralStatisticsDossierGroupingColumnsCaseEnum {
    CASE_TYPE = 'CASE_TYPE',
    PHYSICIAN_CENTER = 'PHYSICIAN_CENTER',
    PHYSICIAN_DEPARTMENT = 'PHYSICIAN_DEPARTMENT',
    PHYSICIAN_PETITIONER = 'PHYSICIAN_PETITIONER',
    PHYSICIAN_HEALTH_MANAGEMENT_AREA = 'PHYSICIAN_HEALTH_MANAGEMENT_AREA',
    PATHOLOGIST = 'PATHOLOGIST',
    DESTINATION_HEALTH_MANAGEMENT_AREA = 'DESTINATION_HEALTH_MANAGEMENT_AREA',
    DESTINATION_CENTER = 'DESTINATION_CENTER',
    DESTINATION_DEPARTMENT= 'DESTINATION_DEPARTMENT',
    DESTINATION = 'DESTINATION',
    PRIORITY = 'PRIORITY',
    REGIME = 'REGIME',
    LABORATORY = 'LABORATORY',
    CASE_OF_REFERENCE = 'CASE_OF_REFERENCE',
    RESIDENT = 'RESIDENT'
}

export enum StatisticalAnalysisGeneralStatisticsDossierGroupingColumnsSampleEnum {
    SAMPLE_TYPE = 'SAMPLE_TYPE',
    TOPOGRAPHIC_CODE = 'TOPOGRAPHIC_CODE',
    GROSSING_TUTOR = 'GROSSING_TUTOR',
    GROSSING_COORDINATOR = 'GROSSING_COORDINATOR',
    GROSSING_TECH_CONTROLLER = 'GROSSING_TECH_CONTROLLER',
    SPECIALIST = 'SPECIALIST',
    VIRTUAL_SHELF = 'VIRTUAL_SHELF',
    MOST_LIKELY_MORPHOLOGIC_CODE = 'MOST_LIKELY_MORPHOLOGIC_CODE',
    PROCEDURE= 'PROCEDURE',
    GROSSING_PROCESSING_RESPONSIBLE = 'GROSSING_PROCESSING_RESPONSIBLE'
}

export enum StatisticalAnalysisGeneralStatisticsDossierGroupingColumnsPortionEnum {
    PORTION_TYPE = 'PORTION_TYPE',
    PORTION_STATE = 'PORTION_STATE',
    PROTOCOL = 'PROTOCOL',
    REGISTER_LIGHT_DATE = 'REGISTER_LIGHT_DATE',
    PROCESSING_END_LIGHT_DATE = 'PROCESSING_END_LIGHT_DATE',
    GENERATION_LIGHT_DATE = 'GENERATION_LIGHT_DATE',
    GENERATION_PERSONNEL = 'GENERATION_PERSONNEL'
}

export enum StatisticalAnalysisGeneralStatisticsDossierGroupingColumnsSubportionEnum {
    SUBPORTION_TYPE = 'SUBPORTION_TYPE',
    ASSAY_GROUP = 'ASSAY_GROUP',
    SUBPORTION_STATE = 'SUBPORTION_STATE',
    ASSAY = 'ASSAY',
    SUBPORTION_PROTOCOL = 'SUBPORTION_PROTOCOL',
    REQUESTER = 'REQUESTER',
    REQUEST_LIGHT_DATE = 'REQUEST_LIGHT_DATE',
    CUT_LIGHT_DATE = 'CUT_LIGHT_DATE',
    STAIN_END_LIGHT_DATE = 'STAIN_END_LIGHT_DATE',
    SCAN_END_LIGHT_DATE = 'SCAN_END_LIGHT_DATE',
    CUTTER = 'CUTTER',
    SUBPORTION_PRIORITY = 'SUBPORTION_PRIORITY'
}

export enum StatisticalAnalysisGeneralStatisticsDossierGroupRequestEnum {
    PATHOLOGIST = 'PATHOLOGIST',
    CASE_TYPE = 'CASE_TYPE',
    PHYSICIAN_DEPARTMENT = 'PHYSICIAN_DEPARTMENT',
    PHYSICIAN_CENTER = 'PHYSICIAN_CENTER',
    PHYSICIAN_PETITIONER = 'PHYSICIAN_PETITIONER',
    DESTINATION_HEALTH_MANAGEMENT_AREA = 'DESTINATION_HEALTH_MANAGEMENT_AREA',
    DESTINATION_CENTER = 'DESTINATION_CENTER',
    DESTINATION = 'DESTINATION',
    PRIORITY = 'PRIORITY',
    REGIME = 'REGIME',
    LABORATORY = 'LABORATORY',
    RESIDENT = 'RESIDENT'
}

export interface StatisticalAnalysisGeneralStatisticsDossierCaseVirtualStateValue {
    code: StatisticalAnalysisCaseTypes,
    name: string
}
export interface StatisticalAnalysisGeneralStatisticsDossierCaseVirtualState {
    state: StatisticalAnalysisGeneralStatisticsDossierCaseVirtualStateValue
    total: number
}
export interface StatisticalAnalysisGeneralStatisticsDossierCase {
    total:number
    totalByState: StatisticalAnalysisGeneralStatisticsDossierCaseVirtualState[]
}

export interface StatisticalAnalysisGeneralStatisticsDossierTrackingElements {
    total:number
    state: StatisticalAnalysisGeneralStatisticsDossierCaseVirtualStateValue
}

export interface StatisticalAnalysisGeneralStatisticsDossierBaseRequest {
    startDate: string,
    endDate: string,
    laboratoryIds?:number[],
    laboratoryUserId:number,
    sameRange:boolean,
    typeIds: number[]
}

export interface StatisticalAnalysisGeneralStatisticsDossierDetailRequest {
    groupByFields: string[]
    infoDetail: StatisticalAnalysisTemporalFilterEnum
}

export interface StatisticalAnalysisGeneralStatisticsDossierGroupRequest {
    groupBy1: string
    groupBy2: string
}

export interface StatisticalAnalysisGeneralStatisticsDossierDetailViewChartResponseInternalGroups {
    name: string
    count: number
}

export interface StatisticalAnalysisGeneralStatisticsDossierDetailViewChart {
    groupBy1: string
    groupBy2: StatisticalAnalysisGeneralStatisticsDossierDetailViewChartResponseInternalGroups[]
}

export interface StatisticalAnalysisGeneralStatisticsDossierDetailViewTableContentCase {
    caseOfReference: Nullable<StatisticalAnalysisViewDetailTableGroupingColumns>
    caseType: Nullable<StatisticalAnalysisViewDetailTableGroupingColumns>
    // TODO Pending to add
    // destination: string
    destinationCenter: Nullable<StatisticalAnalysisViewDetailTableGroupingColumns>
    destinationDepartment: Nullable<StatisticalAnalysisViewDetailTableGroupingColumns>
    destinationHealthManagementArea: Nullable<StatisticalAnalysisViewDetailTableGroupingColumns>
    laboratory: Nullable<StatisticalAnalysisViewDetailTableGroupingColumns>
    pathologist: Nullable<StatisticalAnalysisViewDetailTableGroupingColumns>
    physicianCenter: Nullable<StatisticalAnalysisViewDetailTableGroupingColumns>
    physicianDepartment: Nullable<StatisticalAnalysisViewDetailTableGroupingColumns>
    physicianHealthManagementArea: Nullable<StatisticalAnalysisViewDetailTableGroupingColumns>
    physicianPetitioner: Nullable<StatisticalAnalysisViewDetailTableGroupingColumns>
    priority: Nullable<StatisticalAnalysisViewDetailTableGroupingColumns>
    regime: Nullable<StatisticalAnalysisViewDetailTableGroupingColumns>
    resident: Nullable<StatisticalAnalysisViewDetailTableGroupingColumns>
    stats: StatisticalAnalysisCommonStats
}

export interface StatisticalAnalysisGeneralStatisticsDossierDetailViewTableContentSample extends StatisticalAnalysisGeneralStatisticsDossierDetailViewTableContentCase {
    grossingCoordinator: Nullable<StatisticalAnalysisViewDetailTableGroupingColumns>
    grossingTechController: Nullable<StatisticalAnalysisViewDetailTableGroupingColumns>
    grossingTutor: Nullable<StatisticalAnalysisViewDetailTableGroupingColumns>
    grossingOrProcessingResponsible: Nullable<StatisticalAnalysisViewDetailTableGroupingColumns>
    sampleType: Nullable<StatisticalAnalysisViewDetailTableGroupingColumns>
    specialist: Nullable<StatisticalAnalysisViewDetailTableGroupingColumns>
    mostLikelyMorphologicCode: Nullable<StatisticalAnalysisViewDetailTableGroupingColumns>
    topographicCode: Nullable<StatisticalAnalysisViewDetailTableGroupingColumns>
    virtualShelf: Nullable<StatisticalAnalysisViewDetailTableGroupingColumns>
    procedure: Nullable<StatisticalAnalysisViewDetailTableGroupingColumns>
}

export interface StatisticalAnalysisGeneralStatisticsDossierDetailViewTableContentPortions extends StatisticalAnalysisGeneralStatisticsDossierDetailViewTableContentSample {
    portionState: Nullable<StatisticalAnalysisViewDetailTableGroupingColumns>
    portionType: Nullable<StatisticalAnalysisViewDetailTableGroupingColumns>
    processingEndLightDate: Nullable<StatisticalAnalysisViewDetailTableGroupingColumns>
    protocol: Nullable<StatisticalAnalysisViewDetailTableGroupingColumns>
    registerLightDate: Nullable<StatisticalAnalysisViewDetailTableGroupingColumns>
}

export interface StatisticalAnalysisGeneralStatisticsDossierDetailViewTableContentSubportions extends StatisticalAnalysisGeneralStatisticsDossierDetailViewTableContentPortions {
    assay: Nullable<StatisticalAnalysisViewDetailTableGroupingColumns>
    assayGroup: Nullable<StatisticalAnalysisViewDetailTableGroupingColumns>
    cuttingLightDate: Nullable<StatisticalAnalysisViewDetailTableGroupingColumns>
    cuttingResponsible: Nullable<StatisticalAnalysisViewDetailTableGroupingColumns>
    generationLightDate: Nullable<StatisticalAnalysisViewDetailTableGroupingColumns>
    generationPersonnel: Nullable<StatisticalAnalysisViewDetailTableGroupingColumns>
    registerLightDate: Nullable<StatisticalAnalysisViewDetailTableGroupingColumns>
    requestResponsible: Nullable<StatisticalAnalysisViewDetailTableGroupingColumns>
    requestingLightDate: Nullable<StatisticalAnalysisViewDetailTableGroupingColumns>
    stainEndLightDate: Nullable<StatisticalAnalysisViewDetailTableGroupingColumns>
    subportionPriority: Nullable<StatisticalAnalysisViewDetailTableGroupingColumns>
    subportionProtocol: Nullable<StatisticalAnalysisViewDetailTableGroupingColumns>
    subportionState: Nullable<StatisticalAnalysisViewDetailTableGroupingColumns>
    suportionType: Nullable<StatisticalAnalysisViewDetailTableGroupingColumns>
}

export type StatisticalAnalysisGeneralStatisticsDossierDetailViewTableContent =
    StatisticalAnalysisGeneralStatisticsDossierDetailViewTableContentCase |
    StatisticalAnalysisGeneralStatisticsDossierDetailViewTableContentSample |
    StatisticalAnalysisGeneralStatisticsDossierDetailViewTableContentPortions |
    StatisticalAnalysisGeneralStatisticsDossierDetailViewTableContentSubportions

export interface StatisticalAnalysisGeneralStatisticsDossierDetailViewTable {
    content: StatisticalAnalysisGeneralStatisticsDossierDetailViewTableContent[]
    scrollPage: StatisticalAnalysisContentScrollTable
}

export interface StatisticalAnalysisGeneralStatisticsDossierDetailExternalViewTable {
    content: StatisticalAnalysisExternalListTypes[]
    scrollPage: StatisticalAnalysisContentScrollTable
}
